import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { PrimeIcons } from 'primeng/api';
import { TagModule } from 'primeng/tag';

import { ResourceItem } from '@ppg/core/enums';
import { ResourceValuePipe } from '@ppg/shared/resource';

@Component({
  selector: 'ppg-color-details-description',
  standalone: true,
  imports: [CommonModule, TagModule, ResourceValuePipe],
  templateUrl: './color-details-description.html',
  styleUrl: './color-details-description.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ColorDetailsDescriptionComponent {
  readonly colorDescription = input.required<string>();
  readonly isBestseller = input<boolean>(false);
  readonly bestSellerTag = ResourceItem.COLOR_DETAILS_BEST_SELLER_TAG;
  readonly primeIcons = PrimeIcons;
}
